import React, { useState, useEffect } from 'react'
import {
  ModalOverlay,
  ModalContent,
  ShareModalChatForm,
  StatusMessage,
  CloseIcon,
} from './style'
import { Title, Button, Input } from '../../ui'
import { Dialog, DialogContent, DialogTitle } from '../../ui/dialog/Dialog'
import { getTranslations } from '../../../utils'

// Form content reused in both variants
const SaveChatFormContent = ({
  email,
  setEmail,
  loading,
  status,
  handleSubmit,
}) => (
  <ShareModalChatForm onSubmit={handleSubmit}>
    <Input
      type='email'
      value={email}
      onChange={e => setEmail(e.target.value)}
      placeholder={getTranslations('email') || 'E-mail'}
      required
    />
    <Button type='submit' disabled={loading}>
      {loading
        ? getTranslations('send_chat_sending') || 'Sending...'
        : getTranslations('send_chat') || 'Send chat'}
    </Button>
    <StatusMessage $status={status}>
      {status === 'success'
        ? getTranslations('chat_sent_successfully') || 'Chat sent successfully!'
        : status === 'error'
        ? getTranslations('chat_sent_error') || 'Error sending chat!'
        : '\u00A0'}
    </StatusMessage>
  </ShareModalChatForm>
)

// variant: 'overlay' (default, used in popover) or 'dialog' (full-page)
const SaveChatModal = ({
  isOpen,
  onClose,
  onSubmit,
  top,
  bottom,
  variant = 'overlay',
}) => {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState(null)
  const [loading, setLoading] = useState(false)

  const resetState = () => {
    setEmail('')
    setStatus(null)
    setLoading(false)
  }

  const handleClose = () => {
    resetState()
    onClose && onClose()
  }

  useEffect(() => {
    if (!isOpen) {
      resetState()
    }
  }, [isOpen])

  const handleSubmit = async e => {
    e.preventDefault()
    setLoading(true)
    setStatus(null)

    try {
      await onSubmit({ email })
      setStatus('success')
      setEmail('')
    } catch (err) {
      setStatus('error')
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen) return null

  if (variant === 'dialog') {
    return (
      <Dialog open={isOpen} onOpenChange={open => !open && onClose()}>
        <DialogContent style={{ width: '100%', maxWidth: 480 }}>
          <DialogTitle>
            {getTranslations('send_chat_to_email') || 'Send chat to my email'}
          </DialogTitle>
          <SaveChatFormContent
            email={email}
            setEmail={setEmail}
            loading={loading}
            status={status}
            handleSubmit={handleSubmit}
          />
        </DialogContent>
      </Dialog>
    )
  }

  // overlay variant
  return (
    <ModalOverlay
      $open={isOpen}
      onClick={handleClose}
      top={top}
      bottom={bottom}
    >
      <ModalContent
        $open={isOpen}
        onClick={e => e.stopPropagation()}
        id='modal-content'
      >
        <CloseIcon onClick={handleClose} />
        <Title level={4} style={{ margin: 0, fontSize: '16px' }}>
          {getTranslations('send_chat_to_email') || 'Send chat to my email'}
        </Title>
        <SaveChatFormContent
          email={email}
          setEmail={setEmail}
          loading={loading}
          status={status}
          handleSubmit={handleSubmit}
        />
      </ModalContent>
    </ModalOverlay>
  )
}

export default SaveChatModal
